import { useTranslation } from 'react-i18next';
import { useSettings } from './useSettings';

export function useAppBranding() {
  const { data: settings } = useSettings();
  const { i18n } = useTranslation();
  const lang = i18n.language === 'he' ? 'he' : 'en';

  const companyName = settings?.[`companyName_${lang}`] ?? 'BrainsWay';
  const appName = settings?.[`appName_${lang}`] ?? 'Treatments Reporting';
  const loginSubtitle = settings?.[`loginSubtitle_${lang}`] ?? 'Treatment Reporting Platform';

  // Split appName into two lines for the slogo (e.g. "Treatments" / "Reporting")
  const spaceIdx = appName.indexOf(' ');
  const slogoLine1 = spaceIdx > 0 ? appName.slice(0, spaceIdx) : appName;
  const slogoLine2 = spaceIdx > 0 ? appName.slice(spaceIdx + 1) : '';

  return {
    companyName,
    appName,
    loginSubtitle,
    slogoLine1,
    slogoLine2,
    fullName: `${companyName} ${appName}`,
  };
}
